<template>
  <label class='cm-chiclet' :class="{checked}">
    <input class="cm-chiclet__input"
      v-bind="{
        type,
        value,
        name: group,
        checked
      }"
    />
    <div class="cm-chiclet__label">
      {{ label }}
    </div>
  </label>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: "checkbox"
      },
      value: {
        type: String,
      },
      label: {
        type: String,
      },
      group: { // the html
        type: String,
      }
    },
  }
</script>

<style lang='scss' scoped>
  .cm-chiclet {
    display: inline-block;
    padding: 0.6rem 1rem;
    background: var(--bg-2);
    border-radius: 50px;
    &.checked {
      font-weight: 700;
      background: var(--fg);
      color: var(--bg);
    }
    &__input {
      position: absolute;
      overflow: hidden;
      width: 0;
      height: 0;
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// app/javascript/components/cm-chiclet.vue?baaa000c